import { Bootstrapper } from '@codewyre/wyrekit-composition';
import { Container } from 'inversify';

function application(moduleDefinition, noInit = false) {
  moduleDefinition = Object.assign({
    aliases: [],
    constantValues: [],
    services: [],
    factories: []
  }, moduleDefinition);
  return (constructor) => {
    constructor.module$ = moduleDefinition;
    if (!noInit) {
      setTimeout(async () => await initializeApp(constructor));
    }
    return constructor;
  };
}
async function initializeApp(constructor) {
  const app = new constructor();
  await app.spinUp();
  let bootstrappers = [];
  try {
    bootstrappers = app.container.getAll(Bootstrapper);
  } catch {
  }
  for (const initializer of bootstrappers) {
    await initializer.bootstrap();
  }
  await app.main();
  return app;
}

function transient() {
  return (constructor) => {
    constructor.$transientRuntime = true;
    return constructor;
  };
}

class BaseApp {
  // #endregion
  // #region Ctor
  constructor(baseLogger, log) {
    this.baseLogger = baseLogger;
    this.log = log;
  }
  // #region Private Fields
  _container = null;
  // #endregion
  // #region Properties
  get container() {
    return this._container;
  }
  // #endregion
  // #region Protected Methods
  configureOnActivation() {
    return (_, instance) => {
      const { name } = Object.getPrototypeOf(instance).constructor;
      console.log("Activating " + name);
      instance.log = this.baseLogger.createChild(name);
      return instance;
    };
  }
  buildContainer() {
    const log = this.log.createChild("buildContainer");
    log.debug("Building dependency container");
    const container = new Container();
    const proto = Object.getPrototypeOf(this);
    const { module$ } = proto.constructor;
    this.registerModule(module$, container, log);
    this._container = container;
    log.debug("Finished building container");
    return this;
  }
  registerModule(moduleDefinition, container, log) {
    log.trace("Found module definition", moduleDefinition);
    const { services, constantValues, aliases, factories } = moduleDefinition;
    log.trace("Add services", services);
    for (const service of services ?? []) {
      let binding = container.bind(service).toSelf();
      if (!service.$transientRuntime) {
        binding = binding.inSingletonScope();
      }
      binding.onActivation(this.configureOnActivation());
    }
    log.trace("Add constants", constantValues);
    for (const service of constantValues ?? []) {
      container.bind(service.use).toConstantValue({
        instance: service.withValue
      }).onActivation(this.configureOnActivation());
    }
    log.trace("Add factories", factories);
    for (const service of factories ?? []) {
      container.bind(service.create).toDynamicValue((context) => service.with(
        context,
        this.baseLogger.createChild(`Factory:${typeof service.create === "string" ? service.create : Object.getPrototypeOf(service.create).name}`)
      )).inSingletonScope().onActivation(this.configureOnActivation());
    }
    log.trace("Add services", aliases);
    for (const service of aliases ?? []) {
      container.bind(service.withAlias).to(service.use).inSingletonScope().onActivation(this.configureOnActivation());
      if (service.use.prototype?.constructor?.module$) {
        this.registerModule(service.use.prototype.constructor.module$, container, log);
      }
    }
  }
}

export { BaseApp, application, initializeApp, transient };
//# sourceMappingURL=index.es.js.map
